/* eslint-disable react/style-prop-object */
import React from 'react';
import ReactDOM from 'react-dom/client';
import 'styles/index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { ConfigProvider } from 'antd';
import CrispChat from 'components/crisp';
import { Provider, ErrorBoundary } from '@rollbar/react'; // Provider imports 'rollbar'
import { ROLLBAR_ACCESS_TOKEN } from 'utils/constants';
import { isLocalhost, redirectToNewAppIfMigrated } from 'utils/utils';

const rollbarConfig = {
  accessToken: ROLLBAR_ACCESS_TOKEN,
  environment: isLocalhost() ? 'development' : 'production',
};

// SimplePerf has moved into the BuddiesHR dashboard. If the user already has a
// session, hand it off to the new app before mounting the (legacy) UI.
if (!redirectToNewAppIfMigrated()) {
  const root = ReactDOM.createRoot(document.getElementById('root'));
  root.render(
    // <React.StrictMode>
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: '#776bdf',
          borderRadius: 10,
          // fontFamily: "'silka', sans-serif",
          boxShadow: 'none',
          colorLink: '#776bdf',
          controlHeight: 40,
          fontSize: 14,
          components: {
            Button: {
              colorPrimary: '#776bdf',
              algorithm: true, // Enable algorithm
            },
          },
        },
      }}
    >
      <Provider config={rollbarConfig}>
        <ErrorBoundary>
          <App />
        </ErrorBoundary>
      </Provider>

      {!isLocalhost() && <CrispChat />}
      {/* <SupportChat /> */}
    </ConfigProvider>
    // </React.StrictMode>
  );

  // If you want to start measuring performance in your app, pass a function
  // to log results (for example: reportWebVitals(console.log))
  // or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
  reportWebVitals();
}
